/* .home-title {
  padding-left: 15px;
} */

import styled from 'styled-components';

export const HomeTitle = styled.div`
  padding-left: 15px;
`;
